import React from 'react';

const Logo = ({ className = "h-12 w-auto", color = "black" }) => {
  const isWhite = color === 'white';
  const textColor = isWhite ? 'text-white' : 'text-black';
  const logoUrl = "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1764125335054-Creatica%20Avatar%20%28Circle%29%404x.png";

  return (
    <div className="flex items-center gap-3 select-none">
      <img 
        src={logoUrl} 
        alt="Creatica" 
        className={className} 
      />
      <span className={`font-bold text-3xl tracking-tight ${textColor} font-sans`}>
        Creatica
      </span>
    </div>
  );
};

export default Logo;